import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { DealTransactionStatusEnum } from '../../../../modules/advance-application/models/deal-transaction-status.enum';
import { IExternalDeal } from '../../../../modules/advance-application/models/external-deal.interface';
import { CurrencyJsPipe } from '../../../../modules/pipes/currency-js.pipe';
import { DatePipe } from '../../../../modules/pipes/date.pipe';
import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { DealStatusWithColorComponent } from '../../../../modules/shared/components/deal-status-with-color/deal-status-with-color.component';

@Component({
  selector: 'app-dashboard-upcoming-deals',
  templateUrl: './dashboard-upcoming-deals.component.html',
  styleUrls: ['./dashboard-upcoming-deals.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    LocalisePipe,
    DatePipe,
    CurrencyJsPipe,
    DealStatusWithColorComponent,
  ],
})
export class DashboardUpcomingDealsComponent {
  @Input()
  public list: IExternalDeal[];
  public readonly dealTransactionStatusEnum = DealTransactionStatusEnum;

  public displayedColumns: string[] = [
    'address',
    'closingDate',
    'transactionStatus',
    'commission',
  ];
}
